import { render, staticRenderFns } from "./ModalPolicyData.vue?vue&type=template&id=c279cdb4&"
import script from "./ModalPolicyData.vue?vue&type=script&lang=js&"
export * from "./ModalPolicyData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports